<section class="parker-banner">
    <app-mini-env-banner class="aca-wellness" [subDescription]="'**Services may vary according to your plan.'"
        bgColor="var(--acawellness)" [slides]="bannerSlides"
        (butonAction)="onSliderBtnAction($event)"></app-mini-env-banner>
    <div class="d-flex align-items-center parker-img-row">
        <div class="d-flex align-items-center" style="gap: 10px;">
            <span class="brought-to">Brought to you in collaboration with</span>
        </div>
        <div>
            <div class="d-flex">
                <div>
                    <img [src]="`assets/tenant-assets/images/wow-logo-white.svg`" alt="" class="image-box">
                </div>
            </div>
        </div>
    </div>
</section>


<section class="container-fluid services-section">
    <div class="container">

        <app-mini-env-heading-block [miniTitle]="'Healthcare Benefits'"
            [title]="'Simpler Healthcare with Complete Accessibility'"
            [description]="'Let’s take a deep dive into the value-driven healthcare features we offer, ensuring you get the most out of your healthcare membership.'"
            [style]="'max-width: 703px;'"></app-mini-env-heading-block>

        <div class="responsive-tabs mt-20">
            <ng-container *ngFor="let pane of panes; let i = index">

                <button (click)="select(i)" [class.active]="pane.active" class="tab-btn">
                    {{ pane?.tabTitle }}
                    <span class="accordion-icon"></span>
                </button>

                <div class="tab-body" *ngIf="pane.active">
                    <div class="line"></div>
                    <app-mini-env-content-box [imgSrc]="imgSrc">
                        <h2 class="content-heading">{{ pane?.heading }}</h2>
                        <p class="content-txt">
                            {{ pane?.subHeading }}
                        </p>
                        <ul class="d-flex content-list">
                            <li class="bullet" *ngFor="let item of pane.pointsList">
                                <div>
                                    <img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
                                </div>
                                <div>
                                    <span class="bullet-heading">{{ item?.title }}: </span>
                                    <span>{{ item?.description }}</span>
                                </div>
                            </li>
                        </ul>


                    </app-mini-env-content-box>
                </div>

            </ng-container>
        </div>
    </div>
</section>
<section class="container-fluid bg-white avail-benefits">

    <app-mini-env-heading-block
        [miniTitle]="('BENIFITSMEMBERSHIP.MINI_TITLE' | translateIt: {language: sharedService.currentLanguage} | async)"
        [title]="'Simple Healthcare, Easy Acesss'"
        [description]="'Healthcare doesnt have to be a headache; follow our easy guide to get the straightforward care you deserve without the any hurdles.'"
        [style]="'max-width: 738px;'"></app-mini-env-heading-block>

    <app-imagebox-bullet-scroll [steps]="steps"
        [imgLink]="sharedService.imagesUrl + 'woman-wave-phone.webp'"></app-imagebox-bullet-scroll>
</section>


<section>
    <div class="container-fluid search-section">
        <div class="content-box">
            <div class="search-text-box">
                <app-mini-env-heading-block [miniTitle]="'Search your Medication'"
                    [title]="'Click to Search Your Medications'"
                    [description]="'We have all major medications available either free or at dicounted prices. Search for yours below!'"
                    [leftAlign]="true"></app-mini-env-heading-block>
                <app-search-input [zipCodePlaceholder]="'19064'"
                    [keywordplaceholder]="('SEARCH.INPUT.PLACEHOLDER' | translateIt: {language: sharedService.currentLanguage} | async)"
                    [noData]="noData" (searchAction)=" sharedService.routeToSearch()"
                    (searchChange)="getMedicines($event)" [isLoading]="isLoading" [showSearchIconLeft]='false'
                    [showSearchText]="false" [backgroundColor]="'white'" [locationIcon]="'icons/location-aca.svg'">
                    <div *ngIf="sharedService.results.length != 0" class="results">
                        @for (item of sharedService.results; track $index) {
                        <div class="listing-item" (click)="sharedService.selectPharmacy(item)">
                            <div class="content">
                                <p class="text">{{item.drugName}}</p>
                                @if(item.drugType == "Complete_Care" || item.drugType == "Formulary" || item.drugType == "Acute" || item.drugType == "Acute_only"){
                                <p class="free">Free</p>
                                }
                            </div>
                        </div>
                        }
                    </div>
                </app-search-input>
                <p class="search-description"> Quick search for popular medications:<span> Aspirin, Ibuprofen,
                        Amoxicillin</span></p>

            </div>
            <div class="image-container">
                <img class="man-reading-image" [src]="IMAGES_URL + 'aca-reading-man.svg'" />
            </div>
        </div>
    </div>
</section>


<!-- <section>
    <div class="container-fluid video-section">

        <app-mini-env-heading-block [miniTitle]="'See WoW Health in Action'" [title]="'A Sneak Peek Inside WoW Health'"
            [description]="'Step inside WoW Health and see what makes us different. Thoughtfully designed to support your health journey every step of the way.'"
            [style]="'max-width: 749px;'"></app-mini-env-heading-block>

        <div class="container">
            <app-video-player></app-video-player>
        </div>
    </div>
</section> -->

<!-- <section class="container-fluid login-section" id="membership-section">
    <app-mini-env-heading-block [title]="'Your Medications Just Got Simplified!'"
        [description]="'Skip the pharmacy lines, and start today with the easy and affordable medications in a few clicks'"
        [style]="'max-width: 749px;'"></app-mini-env-heading-block>
    <button (click)="login()" class="login-btn-redirect">Log In to Get Started</button>

    <p class="info">**Services may vary according to your plan.</p>
</section> -->
<section class="container-fluid login-section">
    <app-mini-env-heading-block [title]="'Your Medications Just Got Simplified!'"
        [description]="'Skip the pharmacy lines, and start today with the easy and affordable medications in a few clicks'"
        [discription]="'font-size: 20px !important;'" [style]="'max-width: 749px;'"></app-mini-env-heading-block>
    <button (click)="login()" class="login-btn-redirect">Log In to Get Started</button>
    <p class="info">**Services may vary according to your plan.</p>
</section>
<section class="container-fluid faq-section">
    <div class="container">

        <app-mini-env-heading-block [miniTitle]="'FAQs'" [title]="'Frequently Asked Questions'"
            [description]="'Need help? Our dedicated customer support team is available 24/7 to answer your questions and provide assistance. Call us anytime at 844-969-4325.'"
            [style]="'max-width: 684px;'"></app-mini-env-heading-block>

        <div class="mt-30">
            <app-mini-env-faqs [faqData]="faqList"></app-mini-env-faqs>
        </div>
    </div>
</section>

<!-- <section class="container-fluid footer-section">
   <app-mini-env-sub-footer></app-mini-env-sub-footer>
</section> -->
<!--  How can we help Section End-->